import i18n from '@/lang';

// 账单审核表格表头配置项
export const TABLE_HEADER = [
  // 账单批次号
  { prop: 'billBatchNumber', label: i18n.t('receivablePayable.BillingBatchNumber'), width: 170, align: 'left' },
  // 账单时间
  { prop: 'billingTime', label: i18n.t('receivablePayable.BillingDate'), width: 290 },
  // 账单类型 i18n.t('collectionCenter.TypeBill')
  { prop: 'payableType', label: i18n.t('collectionCenter.TypeBill'), width: 200, align: 'center' },
  // 实际收款人
  { prop: 'actualRecipients', label: i18n.t('basicData.实际收款人'), width: 200, align: 'center' },
  // 账单状态
  { prop: 'billStatusValue', label: i18n.t('receivablePayable.BillingStatus'), width: 160, align: 'left' },
  // 是否请款
  { prop: 'requestPaymentStatus', label: i18n.t('receivablePayable.areYouRequestingPayment'), width: 160, align: 'left' },
  // 付款主体名称
  { prop: 'providerName', label: i18n.t('GlobalSetObj.SubjectPayment'), width: 160, align: 'left' },
  // 网点名称
  { prop: 'siteName', label: i18n.t('basicData.siteName'), width: 160, align: 'left' },
  // 业务类型
  { prop: 'businessType', label: i18n.t('collectionCenter.businessT'), width: 160, align: 'left' },
  // 订单数量
  { prop: 'orderQty', label: i18n.t('receivablePayable.TheNumberOfOrders'), width: 160, align: 'left' },
  // 费用条数
  { prop: 'feeQty', label: i18n.t('receivablePayable.TheNumberOfFees'), width: 160, align: 'left' },
  // 计费总重量（kg）
  { prop: 'chargeWeight', label: i18n.t('receivablePayable.TotalBillableWeight'), width: 160, align: 'left' },
  // 应付总金额
  { prop: 'totalReceivable', label: i18n.t('receivablePayable.TheTotalAmountDue'), width: 160, align: 'left' },
  // 平均每票金额
  { prop: 'agvReceivable', label: i18n.t('receivablePayable.AverageAmountPerVote'), width: 160, align: 'left' },
  // 生成人员
  { prop: 'createUserName', label: i18n.t('receivablePayable.BuildThePerson'), width: 160, align: 'left' },
  // 生成时间
  { prop: 'createTime', label: i18n.t('receivablePayable.BuildTime'), width: 160, align: 'left' },
  // 审核人员
  { prop: 'auditUserName', label: i18n.t('receivablePayable.Auditors'), width: 160, align: 'left' },
  // 审核时间
  { prop: 'auditTime', label: i18n.t('receivablePayable.ReviewTime'), width: 160, align: 'left' },
  // 审核原因
  { prop: 'auditRemark', label: i18n.t('receivablePayable.AuditReason'), width: 160, align: 'left' }
];

// 干支线账单审核表头配置项
export const TRUNK_TABLE_HEADER = [
  // 账单批次号
  { prop: 'billBatchNumber', label: i18n.t('receivablePayable.BillingBatchNumber'), width: 170, align: 'left' },
  // 账单时间
  { prop: 'billingTime', label: i18n.t('receivablePayable.BillingDate'), width: 290 },
  // 账单状态
  { prop: 'billStatusValue', label: i18n.t('receivablePayable.BillingStatus'), width: 160, align: 'left' },
  // 是否请款
  { prop: 'requestPaymentStatus', label: i18n.t('receivablePayable.areYouRequestingPayment'), width: 160, align: 'left' },
  // 付款主体
  { prop: 'providerName', label: i18n.t('GlobalSetObj.SubjectPayment'), width: 200, align: 'left' },
  // 运输类型
  { prop: 'routeType', label: i18n.t('basicData.transportType'), width: 160, align: 'left' },
  // 订单数量
  { prop: 'orderQty', label: i18n.t('receivablePayable.TheNumberOfOrders'), width: 160, align: 'left' },
  // 费用条数
  { prop: 'feeQty', label: i18n.t('receivablePayable.TheNumberOfFees'), width: 160, align: 'left' },
  // 计费总重量（kg）
  { prop: 'chargeWeight', label: i18n.t('receivablePayable.TotalBillableWeight'), width: 160, align: 'left' },
  // 包裹数量
  { prop: 'packageQty', label: i18n.t('receivablePayable.PackageQuantity'), width: 160, align: 'left' },
  // 应付总金额
  { prop: 'totalReceivable', label: i18n.t('receivablePayable.TheTotalAmountDue'), width: 160, align: 'left' },
  // 平均每票金额
  { prop: 'agvReceivable', label: i18n.t('receivablePayable.AverageAmountPerVote'), width: 160, align: 'left' },
  // 生成人员
  { prop: 'createUserName', label: i18n.t('receivablePayable.BuildThePerson'), width: 160, align: 'left' },
  // 生成时间
  { prop: 'createTime', label: i18n.t('receivablePayable.BuildTime'), width: 160, align: 'left' },
  // 审核人员
  { prop: 'auditUserName', label: i18n.t('receivablePayable.Auditors'), width: 160, align: 'left' },
  // 审核时间
  { prop: 'auditTime', label: i18n.t('receivablePayable.ReviewTime'), width: 160, align: 'left' },
  // 审核原因
  { prop: 'auditRemark', label: i18n.t('receivablePayable.AuditReason'), width: 160, align: 'left' }
];
